
import { mapState } from 'vuex'

import { REVIEWS_TYPES } from '@internal-reviews/helpers'
import { ROUTES } from '@router'

import MainHead from '../MainHead'
import Performances from '../Performances'
import SellerDescription from '../SellerDescription'

export const fetch = async ({ store, params, error, redirect }) => {
  const sellerId = params.uuid

  try {
    await store.dispatch('landing/fetchSellerLanding', sellerId)

    const { link } = store.state.landing

    const merchantNameFromLink = link?.params?.merchantName
    if (merchantNameFromLink && merchantNameFromLink !== params?.merchantName) {
      redirect(301, {
        name: ROUTES.LANDING.MERCHANT,
        params: {
          locale: params.locale,
          merchantName: link.params.merchantName,
          // We handle both params name because of the algolia sync delay
          // Vue router will use the one it needs
          uuid: params.uuid,
          id: params.id,
        },
      })
    }

    await store.dispatch('landing/fetchLandingGlobalRate', {
      id: params.uuid,
      type: REVIEWS_TYPES.MERCHANT,
    })
  } catch (err) {
    error({ statusCode: 404, message: 'Seller Not Found' })
  }
}

export default {
  components: {
    Performances,
    MainHead,
    SellerDescription,
  },
  computed: {
    // TODO: Move it to getters
    ...mapState({ sellerDetails: (state) => state.landing }),
    reviewsUrl() {
      const { link } = this.sellerDetails

      if (link?.params?.merchantName && link?.params?.uuid) {
        return {
          type: 'internal',
          name: ROUTES.REVIEWS.PAGES.MERCHANT,
          params: {
            sellerSlug: link.params.merchantName,
            sellerId: link.params.uuid,
          },
        }
      }

      return null
    },
  },
}
